import React from "react";
import Input from "../Inputs/index";
import { CONSTANTS } from "../../constants/Constants";
import Modal from "../Modal";
import SearchableDropdown from "../SelectWithSearch";

interface ModalProps {
  modal_handler: (isOpen: boolean) => void;
  is_btn_disable?: boolean;
  first_input_name: string;
  first_input_label?: string;
  first_input_value: string;
  second_input_name: string;
  second_input_label?: string;
  change_handler: (e: Event | string, name?: string) => void;
  displayNameHandler: (value: string) => void;
  submit_handler: () => void;
  error?: string;
  displayNameMessage: { message: string; success: boolean };
  isModalLoading: boolean;
  titleOptions: { id: string; name: string }[];
}

const CreateProfileModal: React.FC<ModalProps> = ({
  modal_handler,
  change_handler,
  is_btn_disable = true,
  first_input_name,
  first_input_label,
  first_input_value,
  second_input_name,
  second_input_label,
  submit_handler,
  displayNameHandler,
  error,
  isModalLoading,
  titleOptions,
}) => {
  return (
    <Modal
      modal_handler={modal_handler}
      save_handler={submit_handler}
      modal_title={CONSTANTS.CREATE_PROFILE}
      is_btn_disable={is_btn_disable || isModalLoading}
      other_classes="md:w-1/3 w-[80%]"
    >
      <div>
        <div className="mt-4 space-y-4 w-">
          <div className="space-y-2">
            <label className="text-sm">
              {first_input_label}
              <span className="text-error mr-1">*</span>
            </label>
            <Input
              on_blur={displayNameHandler}
              input_name={first_input_name || ""}
              value={first_input_value || ""}
              change_handler={change_handler}
              placeholder="Enter here"
              other_classes="text-sm h-9"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm">
              {second_input_label}
              <span className="text-error mr-1">*</span>
            </label>
            <SearchableDropdown
              options={titleOptions}
              onAddOption={(value: string) => {
                change_handler(value, second_input_name);
              }}
              name={second_input_name}
              otherClasses="text-sm h-9"
            />
          </div>
        </div>
        <small className="mt-2 text-error">{error}</small>
      </div>
    </Modal>
  );
};

export default CreateProfileModal;
